/**
 * LocationLayout
 *
 * Full-height content shell for /location/* pages.
 * LocationProvider and the site/floor selector live in the app shell (InsightApp).
 */

import React from 'react';
import { Box } from '@mui/material';
import { useAppToolbarOffset } from '../../contexts/AppToolbarContext';

interface Props {
  children: React.ReactNode;
}

const LocationLayout: React.FC<Props> = ({ children }) => {
  const toolbarOffset = useAppToolbarOffset();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: `calc(100vh - ${toolbarOffset}px)`,
        minHeight: 0,
        overflow: 'hidden',
      }}
    >
      {children}
    </Box>
  );
};

export default LocationLayout;
